import {
  type AllDualVariantIconKeys,
  Heading,
  Stack,
  Sticker,
} from "@biom3/react";
import { Card, CardContent, Typography } from "@mui/material";

interface StatsCardProps {
  title: string;
  value: string | number;
  valueIcon?: React.ReactNode;
  icon: AllDualVariantIconKeys;
}
export const StatsCard = ({
  title,
  value,
  valueIcon,
  icon,
}: StatsCardProps) => {
  return (
    <Card
      variant="outlined"
      sx={{ width: "100%", height: "100px", background: "#252525" }}
    >
      <CardContent
        sx={{
          p: 3,
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Stack
          direction="row"
          sx={{
            display: "flex",
            width: "100%",
          }}
          gap="base.spacing.x4"
        >
          <Sticker.FramedIcon
            icon={icon}
            variant="bold"
            emphasized={false}
            sx={{
              w: "base.icon.size.500",
              h: "base.icon.size.500",
              fill: "base.color.fixed.white.1000",
              visibility: "visible",
              boxShadow: "0",
            }}
          />
          <Stack gap="0">
            <Typography variant="caption" color="text.secondary">
              {title}
            </Typography>
            <Stack direction="row" gap="base.spacing.x1" alignItems="center">
              <Heading size="small" weight="bold">
                {value}
              </Heading>
              {valueIcon}
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
